import React, { Component } from 'react';
import '../css/styleHome.css';
import { Col, Row, Label, FormGroup, Button, Progress } from 'reactstrap';
import HeaderComp from "../components/HeaderAgenteLogin"
import fondo from "../imgs/KLBackground.png"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validarUsuario, validarAgente, sesionAgente } from "../actions/index";
import MensajeModal from "../components/MensajeModal"
import MicrosoftLog from "../components/LoginMicrosoft"
import { Redirect } from 'react-router-dom';
import axios from "axios";
import { OBTENER_URL_SERVICIO } from "../constants/action-types";

const mapStateToProps = state => {
  return { respuestaLogin: state.respuestaLogin };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ validarUsuario, validarAgente, sesionAgente }, dispatch)
  };
};

class LoginAgentes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEstado: false,
      modalTitulo: "",
      modalMensaje: "",
      modalFooter: "",
      validacion: false,
      validacionAdmin: false,
      agente: {
        //nombreAgente:""
        //apellidoAgente:""
        //correoAgente:""
      },
    };
    this.toggle = this.toggle.bind(this);
    this.modalAyuda = this.modalAyuda.bind(this);
    this.validarToken = this.validarToken.bind(this);
    this.buscarRoles = this.buscarRoles.bind(this);
    this.modalRolesLogin = this.modalRolesLogin.bind(this);
    this.confirmacionBoton = this.confirmacionBoton.bind(this)
  }

  componentDidMount() {
    document.title = "DigiturnoKL - Login Agente";
  }

  modalAyuda() {
    this.setState({
      modalTitulo: "Ayuda",
      modalMensaje:
        <div>
          <p>Este es el inicio de sesión para los Agentes que atenderán los servicios solicitados por los usuarios del Sistema de Gestión de Turnos.</p>
          <p>Para continuar, haz click en el botón: "Inicia sesión con tu cuenta institucional" y serás redirigido al inicio de sesión seguro de Outlook.</p>
          <p></p>
          <p>Si tienes problemas, alguna queja o duda sobre el funcionamiento, comunicate al:</p>
          <p>(+57-1) 347 2311 ext. 186 (Departamento de TI)</p>
          <p></p>
          <p>En el Departamento de TI de la universidad estamos atentos a tus sugerencias, recomendaciones o problemas durante este proceso.</p>
        </div>,
      modalFooter: <Button onClick={this.toggle}> Cerrar</Button>
    })
    this.toggle();
  }

  toggle() {
    this.setState({
      modalEstado: !this.state.modalEstado
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.respuestaLogin !== undefined) {
      setTimeout(
        function () {
          console.log(nextProps)
          if (nextProps.respuestaLogin.tipo === "ERROR") {
            this.setState({
              modalTitulo: "ERROR",
              modalMensaje:
                <div>
                  <center>
                    <p>Usuario no registrado.</p>
                    <p>Si crees que es un error, da click en el botón "Ayuda" para recibir apoyo.</p>
                  </center>
                </div>,
              modalFooter: <Button onClick={this.toggle}> Cerrar</Button>,
            })
          } else {
            this.buscarRoles();
          }
        }
          .bind(this),
        10
      );
    }
  }

  validarToken(data) {
    //console.log(data.access_token)
    this.setState({
      modalTitulo: "Espera por favor",
      modalMensaje:
        <div>
          <center>
            <p>¡Estamos validando tus datos!</p>
          </center>
        </div>,
      modalFooter: <div style={{ width: "100%" }}>
        <Progress animated color="success" value="100" />
      </div>,
    })

    this.toggle();
    setTimeout(
      function () {
        console.log(data)
        //var base64Url = data.access_token.split('.')[1];
      var base64Url = data.accessToken.split('.')[1];
        if (base64Url === undefined) {
          this.setState({
            modalTitulo: "ERROR",
            modalMensaje:
              <div>
                <center>
                  <p>Usuario no registrado.</p>
                  <p>Si crees que es un error, da click en el botón "Ayuda" para recibir apoyo.</p>
                </center>
              </div>,
            modalFooter: <Button onClick={this.toggle}> Cerrar</Button>,
          })
        } else {
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var y = JSON.parse(window.atob(base64));
          //console.log(y)
          var agentex = {
            nombreAgente: y.given_name,
            apellidoAgente: y.family_name,
            correoAgente: y.unique_name,
          }
          this.setState({
            agente: agentex
          })
          //console.log(this.state.agente)
          this.props.validarAgente(y.unique_name);
        }
      }
        .bind(this),
      10
    );

  }

  async buscarRoles() {
    try {
      const response = await axios.get(OBTENER_URL_SERVICIO + "/rolesCorreoCliente/" + this.state.agente.correoAgente);
      if (response.data.length > 1) {
        this.modalRolesLogin(response.data);
      }
      else {
        if (response.data[0].namRol !== "Agente") {
          this.datosConfirmados("Administrador");
        }
        else {
          this.datosConfirmados("Agente");
        }
      }
    } catch (error) {
      this.setState({
        modalTitulo: "ERROR",
        modalMensaje:
          <div>
            <center>
              <p>Por favor intenta de nuevo más tarde.</p>
            </center>
          </div>,
        modalFooter: <Button onClick={this.toggle}> Cerrar</Button>,
      })
    }
  }

  modalRolesLogin(datos) {
    //console.log(datos)
    var rol = datos.map(p => {
      return (
        <center key={p.secRol + "*-*" + p.namRol}>
          <Button color="primary" style={{ marginRight: "5px" }} id={p.namRol} onClick={this.confirmacionBoton} key={p.secRol + "*-*" + p.namRol} > {p.namRol}</Button>
          <br /><br />
        </center>
      )
    });
    //console.log(rol)
    var x = <div key="RolesCliente" style={{ width: "100%" }}>
      {rol}
    </div>
    //console.log(x)
    this.setState({
      modalTitulo: "Selecciona un rol",
      modalMensaje:
        <div>
          <p>Selecciona el rol con el que deseas continuar:</p>
        </div>,
      modalFooter: x
    })
  }

  async confirmacionBoton(event) {
    if (event.target.id === "Agente") {
      try {
        const response = await axios.get(OBTENER_URL_SERVICIO + "/clienteCorreoCliente/" + this.state.agente.correoAgente);
        var agentex = {
          nombreAgente: response.data.nombreAgente,
          apellidoAgente: response.data.apellidoAgente,
          correoAgente: response.data.correoAgente,
          identificacionAgente: response.data.cedulaAgente,
          areaAgente: response.data.area,
          mapaServicios: response.data.mapaServicios,
        }
        this.setState({
          agente: agentex
        })
        this.props.sesionAgente(agentex);
        setTimeout(
          function () {
            this.setState({ validacion: true })
          }
            .bind(this),
          10
        );
      } catch (error) {
        //console.error(error);
      }
    }
    else {
      if (event.target.id === "Administrador") {
        this.props.sesionAgente(this.state.agente);
        setTimeout(
          function () {
            this.setState({ validacionAdmin: true })
          }
            .bind(this),
          10
        );
      }
      else {
        if (event.target.id === "Directivo") {
          this.props.sesionAgente(this.state.agente);
          setTimeout(
            function () {
              this.setState({ validacionDirectivo: true })
            }
              .bind(this),
            10
          );
        }
      }
    }
  }

  async datosConfirmados(rol) {
    if (rol === "Agente") {
      try {
        const response = await axios.get(OBTENER_URL_SERVICIO + "/clienteCorreoCliente/" + this.state.agente.correoAgente);
        var agentex = {
          nombreAgente: response.data.nombreAgente,
          apellidoAgente: response.data.apellidoAgente,
          correoAgente: response.data.correoAgente,
          identificacionAgente: response.data.cedulaAgente,
          areaAgente: response.data.area,
          mapaServicios: response.data.mapaServicios,
        }
        this.setState({
          agente: agentex
        })
        this.props.sesionAgente(agentex);
        setTimeout(
          function () {
            this.setState({ validacion: true })
          }
            .bind(this),
          10
        );
      } catch (error) {
        //console.error(error);
      }
    }
    else {
      if (rol === "Administrador") {
        this.props.sesionAgente(this.state.agente);
        setTimeout(
          function () {
            this.setState({ validacionAdmin: true })
          }
            .bind(this),
          10
        );
      }
      else {
        if (rol === "Directivo") {
          this.props.sesionAgente(this.state.agente);
          setTimeout(
            function () {
              this.setState({ validacionDirectivo: true })
            }
              .bind(this),
            10
          );
        }
      }
    }
  }

  render() {
    if (this.state.validacion === true) {
      return <Redirect to={{ pathname: '/Cliente/Agente' }} />
    }
    if (this.state.validacionAdmin === true) {
      return <Redirect to={{ pathname: '/Cliente/Admin' }} />
    }
    if (this.state.validacionDirectivo === true) {
      return <Redirect to={{ pathname: '/Cliente/Directivo' }} />
    }
    return (
      <div>
        <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
        <div id="home">
          <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
            <div className="overlay"></div>
          </div>
          <div className="home-wrapper">
            <div className="container">
              <Row>
                <Col xs="12">
                  <div className="home-content">
                    <HeaderComp></HeaderComp>
                    <Col xs="12">
                      <Row>
                        <Col xs="1" sm="2" md="3"></Col>
                        <Col xs="10" sm="8" md="6">
                          <center>
                            <FormGroup>
                              <Label cfor="exampleEmail"><h3>Sistema de Gestión de Turnos</h3></Label>
                              <Label cfor="exampleEmail"><h3>Inicio de sesión de agentes</h3></Label>
                              <br />
                              <MicrosoftLog functionToken={this.validarToken} />
                              <br />
                              <Button color="info" onClick={this.modalAyuda} size="md">ayuda</Button>
                            </FormGroup>
                          </center>
                        </Col>
                        <Col xs="1" sm="2" md="3"></Col>
                      </Row>
                    </Col>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginAgentes);